import { render, staticRenderFns } from "./dash_detail.vue?vue&type=template&id=8305c61a&scoped=true&"
import script from "./dash_detail.vue?vue&type=script&lang=js&"
export * from "./dash_detail.vue?vue&type=script&lang=js&"
import style0 from "./dash_detail.vue?vue&type=style&index=0&id=8305c61a&prod&scoped=true&lang=css&"
import style1 from "./dash_detail.vue?vue&type=style&index=1&id=8305c61a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8305c61a",
  null
  
)

export default component.exports